import { getAnnouncements } from '@services/external/announcements.api';
import { useQuery, UseQueryOptions } from 'react-query';
import { TGetAlertsParams } from 'types/alerts';

async function handler(params: TGetAlertsParams) {
  const { data } = await getAnnouncements(params);
  return data.data;
}

type TQueryData = Awaited<ReturnType<typeof handler>>;

function useAnnouncementsHistory(
  params: TGetAlertsParams,
  options?: UseQueryOptions<TQueryData, unknown, TQueryData, any[]>,
) {
  return useQuery(['announcements:history', params], () => handler(params), options);
}

export default useAnnouncementsHistory;
